<div class="prospect-companies">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '32rem' }"></p-confirmDialog>

  <!-- En-tête -->
  <div class="page-header">
    <div>
      <h1>Prospects B2B</h1>
      <p class="sous-titre">
        {{ totalCount | number }} entreprise(s) — seuls les prospects à
        <strong>score ≥ {{ referentiels?.score_minimum_travaillable || 60 }}</strong>
        doivent entrer en séquence.
      </p>
    </div>
    <div class="header-actions">
      <button
        pButton
        type="button"
        label="Tableau de bord"
        icon="pi pi-chart-line"
        class="p-button-text"
        routerLink="/cac/prospection"
      ></button>
      <button
        pButton
        type="button"
        label="Importer un CSV"
        icon="pi pi-upload"
        class="p-button-outlined"
        (click)="importVisible = true"
      ></button>
    </div>
  </div>

  <!-- Filtres -->
  <div class="barre-filtres">
    <span class="p-input-icon-left champ-recherche">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="search"
        (keyup.enter)="appliquerFiltres()"
        placeholder="Raison sociale, SIREN, ville, dirigeant…"
      />
    </span>

    <p-dropdown
      [options]="optionsStatut"
      [(ngModel)]="filters.statut"
      (onChange)="appliquerFiltres()"
      optionLabel="label"
      optionValue="value"
      placeholder="Statut"
      [showClear]="true"
      styleClass="filtre"
    ></p-dropdown>

    <p-dropdown
      [options]="optionsProduit"
      [(ngModel)]="filters.produit_cible"
      (onChange)="appliquerFiltres()"
      optionLabel="label"
      optionValue="value"
      placeholder="Produit"
      [showClear]="true"
      styleClass="filtre"
    ></p-dropdown>

    <p-dropdown
      [options]="optionsSecteur"
      [(ngModel)]="filters.secteur"
      (onChange)="appliquerFiltres()"
      optionLabel="label"
      optionValue="value"
      placeholder="Secteur"
      [showClear]="true"
      styleClass="filtre"
    ></p-dropdown>

    <input
      pInputText
      type="text"
      class="champ-court"
      [(ngModel)]="filters.departement"
      (keyup.enter)="appliquerFiltres()"
      placeholder="Dépt"
      maxlength="3"
    />

    <p-dropdown
      [options]="optionsScoreMin"
      [(ngModel)]="filters.score_min"
      (onChange)="appliquerFiltres()"
      optionLabel="label"
      optionValue="value"
      placeholder="Score"
      styleClass="filtre"
    ></p-dropdown>

    <p-dropdown
      [options]="optionsTrigger"
      [(ngModel)]="filters.avec_trigger"
      (onChange)="appliquerFiltres()"
      optionLabel="label"
      optionValue="value"
      placeholder="Signal"
      styleClass="filtre"
    ></p-dropdown>

    <p-dropdown
      [options]="optionsTri"
      [(ngModel)]="filters.tri"
      (onChange)="appliquerFiltres()"
      optionLabel="label"
      optionValue="value"
      styleClass="filtre"
    ></p-dropdown>

    <button
      pButton
      type="button"
      icon="pi pi-filter-slash"
      class="p-button-text"
      pTooltip="Réinitialiser les filtres"
      (click)="reinitialiserFiltres()"
    ></button>
  </div>

  <!-- Tableau -->
  <div class="table-card">
    <p-table
      [value]="companies"
      dataKey="id"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [loading]="loading"
      [paginator]="true"
      [first]="first"
      [rows]="pageSize"
      [totalRecords]="totalCount"
      [rowsPerPageOptions]="[25, 50, 100]"
      currentPageReportTemplate="{first} à {last} sur {totalRecords}"
      [showCurrentPageReport]="true"
      styleClass="p-datatable-sm p-datatable-gridlines"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="col-score">Score</th>
          <th>Entreprise</th>
          <th>Secteur</th>
          <th class="col-effectif">Effectif</th>
          <th>Localisation</th>
          <th>Produit d'attaque</th>
          <th>Signaux</th>
          <th>Statut</th>
          <th class="col-contacts">Contacts</th>
          <th class="col-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-company>
        <tr>
          <td class="col-score">
            <p-tag
              [value]="company.score"
              [severity]="severiteScore(company.score)"
              [pTooltip]="'Composantes du score : ' + (company.score_detail | json)"
            ></p-tag>
          </td>

          <td>
            <div class="cellule-entreprise">
              <a class="lien-entreprise" (click)="ouvrirDetail(company)">
                {{ company.raison_sociale }}
              </a>
              <span class="meta">
                SIREN {{ company.siren }}
                <ng-container *ngIf="company.dirigeant_nom">
                  · {{ company.dirigeant_prenom }} {{ company.dirigeant_nom }}
                </ng-container>
              </span>
            </div>
          </td>

          <td>{{ libelleSecteur(company.secteur) }}</td>

          <td class="col-effectif">{{ effectif(company) }}</td>

          <td>
            <span class="ville">{{ company.ville || '—' }}</span>
            <span class="meta" *ngIf="company.code_postal">{{ company.code_postal }}</span>
          </td>

          <td>
            <span class="produit">{{ libelleProduit(company.produit_cible) }}</span>
            <span class="badge-ria" *ngIf="eligibleRia(company)" pTooltip="Contrat de plus de 12 mois : la santé collective est résiliable à tout moment">
              RIA
            </span>
          </td>

          <td>
            <div class="signaux" *ngIf="company.triggers?.length; else aucunSignal">
              <span
                class="puce-signal"
                *ngFor="let trigger of company.triggers.slice(0, 2)"
                [pTooltip]="trigger.libelle"
              >
                {{ libelleTrigger(trigger.type) }}
              </span>
              <span class="meta" *ngIf="company.triggers.length > 2">
                +{{ company.triggers.length - 2 }}
              </span>
            </div>
            <ng-template #aucunSignal><span class="meta">—</span></ng-template>
          </td>

          <td>
            <p-tag
              [value]="libelleStatut(company.statut)"
              [severity]="severiteStatut(company.statut)"
            ></p-tag>
          </td>

          <td class="col-contacts">
            <span class="compteur-contacts">{{ company.contacts?.length || 0 }}</span>
            <i
              class="pi pi-phone icone-appelable"
              *ngIf="contactsAppelables(company) > 0"
              [pTooltip]="contactsAppelables(company) + ' contact(s) appelable(s) : consentement écrit enregistré'"
            ></i>
          </td>

          <td class="col-actions">
            <button
              pButton
              type="button"
              icon="pi pi-eye"
              class="p-button-text p-button-sm"
              pTooltip="Ouvrir la fiche"
              (click)="ouvrirDetail(company)"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-user-plus"
              class="p-button-text p-button-sm"
              pTooltip="Ajouter un contact"
              (click)="ouvrirAjoutContact(company)"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-refresh"
              class="p-button-text p-button-sm"
              pTooltip="Recalculer le score"
              (click)="rescorer(company)"
            ></button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" class="tableau-vide">
            <p>Aucun prospect ne correspond aux filtres.</p>
            <p class="meta">
              Lancez une collecte :
              <code>python -m app.scripts.prospection_harvest --departements 75,92 --apply</code>
            </p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ============================ Fiche prospect ============================ -->
<p-dialog
  [(visible)]="detailVisible"
  [modal]="true"
  [style]="{ width: '58rem' }"
  [draggable]="false"
  [header]="companySelectionnee?.raison_sociale || 'Prospect'"
>
  <div class="fiche" *ngIf="companySelectionnee as company">

    <div class="fiche-entete">
      <p-tag
        [value]="'Score ' + company.score + '/100'"
        [severity]="severiteScore(company.score)"
      ></p-tag>
      <p-tag
        [value]="libelleStatut(company.statut)"
        [severity]="severiteStatut(company.statut)"
      ></p-tag>
      <span class="fiche-produit">{{ libelleProduit(company.produit_cible) }}</span>
    </div>

    <p class="motif" *ngIf="motifProduit(company)">
      <i class="pi pi-lightbulb"></i> {{ motifProduit(company) }}
    </p>

    <div class="fiche-grille">
      <div><span class="etiquette">SIREN</span>{{ company.siren }}</div>
      <div><span class="etiquette">Forme juridique</span>{{ company.forme_juridique || '—' }}</div>
      <div><span class="etiquette">NAF</span>{{ company.naf_code || '—' }}</div>
      <div><span class="etiquette">Secteur</span>{{ libelleSecteur(company.secteur) }}</div>
      <div><span class="etiquette">Effectif</span>{{ effectif(company) }} salariés</div>
      <div><span class="etiquette">Création</span>{{ company.date_creation ? (company.date_creation | date: 'dd/MM/yyyy') : '—' }}</div>
      <div class="pleine-ligne">
        <span class="etiquette">Adresse</span>
        {{ company.adresse || '—' }} · {{ company.code_postal }} {{ company.ville }}
      </div>
      <div class="pleine-ligne" *ngIf="company.dirigeant_nom">
        <span class="etiquette">Dirigeant</span>
        {{ company.dirigeant_prenom }} {{ company.dirigeant_nom }}
        <em *ngIf="company.dirigeant_qualite">({{ company.dirigeant_qualite }})</em>
      </div>
    </div>

    <!-- Détail du score -->
    <h3>Composition du score</h3>
    <div class="composantes">
      <div class="composante" *ngFor="let composante of composantesScore(company)">
        <span>{{ composante.cle }}</span>
        <strong [class.nul]="!composante.valeur">+{{ composante.valeur }}</strong>
      </div>
    </div>

    <!-- Signaux -->
    <h3 *ngIf="company.triggers?.length">Signaux d'achat détectés</h3>
    <ul class="liste-signaux" *ngIf="company.triggers?.length">
      <li *ngFor="let trigger of company.triggers">
        <strong>{{ libelleTrigger(trigger.type) }}</strong>
        <span class="meta" *ngIf="trigger.date"> — {{ trigger.date | date: 'dd/MM/yyyy' }}</span>
        <span class="meta" *ngIf="trigger.source"> · {{ trigger.source }}</span>
        <span class="badge-confiance" *ngIf="trigger.confiance">
          confiance {{ trigger.confiance }}
        </span>
        <div class="meta" *ngIf="trigger.libelle">{{ trigger.libelle }}</div>
      </li>
    </ul>

    <!-- Contacts -->
    <h3>
      Contacts nominatifs
      <button
        pButton
        type="button"
        label="Ajouter"
        icon="pi pi-plus"
        class="p-button-text p-button-sm"
        (click)="ouvrirAjoutContact(company)"
      ></button>
    </h3>

    <div class="zone-chargement" *ngIf="chargementDetail">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
    </div>

    <p class="meta" *ngIf="!chargementDetail && !contactsDuProspect.length">
      Aucun contact nominatif. Ajoutez le dirigeant pour pouvoir démarrer une séquence.
    </p>

    <div class="carte-contact" *ngFor="let contact of contactsDuProspect">
      <div class="contact-tete">
        <div>
          <strong>{{ contact.prenom }} {{ contact.nom }}</strong>
          <span class="meta" *ngIf="contact.fonction"> — {{ contact.fonction }}</span>
        </div>
        <div class="contact-etats">
          <p-tag *ngIf="contact.opposition" value="Opposition RGPD" severity="danger"></p-tag>
          <p-tag
            *ngIf="!contact.opposition && contact.appel_autorise"
            value="Appel autorisé"
            severity="success"
          ></p-tag>
          <p-tag
            *ngIf="!contact.opposition && !contact.appel_autorise"
            value="Appel bloqué"
            severity="warn"
            pTooltip="Aucune réponse écrite enregistrée : l'appel à froid est interdit depuis le 11/08/2026"
          ></p-tag>
        </div>
      </div>

      <div class="contact-canaux">
        <span *ngIf="contact.email_pro"><i class="pi pi-envelope"></i> {{ contact.email_pro }}</span>
        <span *ngIf="contact.telephone_pro"><i class="pi pi-phone"></i> {{ contact.telephone_pro }}</span>
        <a *ngIf="contact.linkedin_url" [href]="contact.linkedin_url" target="_blank" rel="noopener">
          <i class="pi pi-linkedin"></i> LinkedIn
        </a>
        <span class="meta">Étape séquence : {{ contact.sequence_etape }}</span>
      </div>

      <div class="contact-actions" *ngIf="!contact.opposition">
        <button
          pButton
          type="button"
          label="Invitation"
          icon="pi pi-linkedin"
          class="p-button-sm p-button-outlined"
          (click)="journaliser(contact, 'LINKEDIN', 'LINKEDIN_INVITATION')"
        ></button>
        <button
          pButton
          type="button"
          label="Message"
          icon="pi pi-comment"
          class="p-button-sm p-button-outlined"
          (click)="journaliser(contact, 'LINKEDIN', 'LINKEDIN_MESSAGE')"
        ></button>
        <button
          pButton
          type="button"
          label="Email"
          icon="pi pi-send"
          class="p-button-sm p-button-outlined"
          (click)="journaliser(contact, 'EMAIL', 'EMAIL_ENVOYE')"
        ></button>
        <button
          pButton
          type="button"
          label="Appel"
          icon="pi pi-phone"
          class="p-button-sm p-button-outlined"
          [disabled]="!contact.appel_autorise"
          [pTooltip]="contact.appel_autorise ? 'Journaliser un appel' : 'Enregistrez d\'abord la réponse écrite du prospect'"
          (click)="journaliser(contact, 'TELEPHONE', 'APPEL')"
        ></button>
        <button
          pButton
          type="button"
          label="RDV"
          icon="pi pi-calendar-plus"
          class="p-button-sm"
          (click)="journaliser(contact, 'AUTRE', 'RDV_PRIS')"
        ></button>

        <span class="separateur"></span>

        <button
          pButton
          type="button"
          label="Réponse reçue"
          icon="pi pi-check-circle"
          class="p-button-sm p-button-success"
          *ngIf="!contact.appel_autorise"
          (click)="ouvrirConsentement(contact)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-ban"
          class="p-button-sm p-button-text p-button-danger"
          pTooltip="Enregistrer une opposition RGPD"
          (click)="confirmerOpposition(contact)"
        ></button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Fermer"
      icon="pi pi-times"
      class="p-button-text"
      (click)="detailVisible = false"
    ></button>
    <button
      pButton
      type="button"
      label="Convertir en contact CRM"
      icon="pi pi-user-plus"
      [disabled]="companySelectionnee?.statut === 'CONVERTI'"
      (click)="convertir(companySelectionnee!)"
    ></button>
  </ng-template>
</p-dialog>

<!-- ============================ Ajout de contact ============================ -->
<p-dialog
  [(visible)]="contactVisible"
  [modal]="true"
  [style]="{ width: '32rem' }"
  header="Ajouter un contact"
  [draggable]="false"
>
  <div class="formulaire">
    <label>Prénom</label>
    <input pInputText type="text" [(ngModel)]="nouveauContact.prenom" />

    <label>Nom</label>
    <input pInputText type="text" [(ngModel)]="nouveauContact.nom" />

    <label>Fonction</label>
    <input pInputText type="text" [(ngModel)]="nouveauContact.fonction" />

    <label>Persona</label>
    <p-dropdown
      [options]="optionsPersona"
      [(ngModel)]="nouveauContact.persona"
      optionLabel="label"
      optionValue="value"
      placeholder="Choisir"
    ></p-dropdown>

    <label>URL LinkedIn</label>
    <input pInputText type="text" [(ngModel)]="nouveauContact.linkedin_url" />

    <label>Email professionnel</label>
    <input pInputText type="email" [(ngModel)]="nouveauContact.email_pro" />

    <label>Téléphone professionnel</label>
    <input pInputText type="text" [(ngModel)]="nouveauContact.telephone_pro" />

    <p class="note-formulaire">
      <i class="pi pi-info-circle"></i>
      Le téléphone reste bloqué tant qu'aucune réponse écrite n'a été enregistrée.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" class="p-button-text" (click)="contactVisible = false"></button>
    <button pButton type="button" label="Enregistrer" icon="pi pi-check" (click)="enregistrerContact()"></button>
  </ng-template>
</p-dialog>

<!-- ============================ Consentement ============================ -->
<p-dialog
  [(visible)]="consentementVisible"
  [modal]="true"
  [style]="{ width: '34rem' }"
  header="Enregistrer la réponse du prospect"
  [draggable]="false"
>
  <p class="explication">
    Depuis l'entrée en vigueur de l'opt-in le 11/08/2026, un appel doit pouvoir être
    justifié. Collez ci-dessous la réponse reçue : elle est conservée comme preuve et
    débloque le canal téléphonique pour ce contact.
  </p>

  <div class="formulaire">
    <label>Canal de la réponse</label>
    <p-dropdown
      [options]="optionsConsentement"
      [(ngModel)]="consentementSource"
      optionLabel="label"
      optionValue="value"
      placeholder="Choisir"
    ></p-dropdown>

    <label>Verbatim de la réponse</label>
    <textarea
      pTextarea
      rows="5"
      [(ngModel)]="consentementPreuve"
      placeholder="Ex. : « Bonjour, oui le sujet nous intéresse, vous pouvez m'appeler jeudi après-midi. »"
    ></textarea>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" class="p-button-text" (click)="consentementVisible = false"></button>
    <button
      pButton
      type="button"
      label="Enregistrer et débloquer l'appel"
      icon="pi pi-check"
      [disabled]="!consentementSource"
      (click)="enregistrerConsentement()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ============================ Import CSV ============================ -->
<p-dialog
  [(visible)]="importVisible"
  [modal]="true"
  [style]="{ width: '32rem' }"
  header="Importer un CSV de collecte"
  [draggable]="false"
>
  <p class="explication">
    Fichier produit par <code>app.scripts.prospection_harvest</code> — séparateur « ; »,
    UTF-8. Les entreprises déjà en base sont mises à jour, jamais dupliquées (clé SIREN).
  </p>

  <div class="formulaire">
    <label>Fichier CSV</label>
    <input type="file" accept=".csv" (change)="onFichierSelectionne($event)" />

    <label>Nom de campagne (facultatif)</label>
    <input pInputText type="text" [(ngModel)]="campagneImport" placeholder="Ex. S34-IDF" />
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" class="p-button-text" (click)="importVisible = false"></button>
    <button
      pButton
      type="button"
      label="Importer"
      icon="pi pi-upload"
      [disabled]="!fichierImport || importEnCours"
      [loading]="importEnCours"
      (click)="lancerImport()"
    ></button>
  </ng-template>
</p-dialog>
